module.exports = new __parcel__URL__("logo_envsn.673d6776.svg").toString();